export const getRandomElement = <TArray>(array?: TArray[]) => {
    if (!array || array.length === 0) {
        return;
    }

    return array[Math.floor(Math.random() * array.length)];
};
export const getRandomElement = <TArray>(array?: TArray[]) => {
    if (!array || array.length === 0) {
        return;
    }

    return array[Math.floor(Math.random() * array.length)];
};
